import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import {
  i18nTranslate,
  capitalizeFirstLetter,
  isSepaPaymentRecord,
} from 'src/utils'
import { customerContainer, multipleSubscriptionContainer } from 'src/models'

class PaymentDeleteModal extends React.Component {
  handleDeleteConfirmationModalClose = () => {
    this.props.toggleDeleteConfirmationModal()
  }

  handleDeletePayment = async () => {
    const { selectedPaymentForDelete } = this.props
    const paymentId = selectedPaymentForDelete?.id || 0
    if (paymentId) {
      let response =
        await multipleSubscriptionContainer.deletePaymentById(paymentId)
      if (multipleSubscriptionContainer.isSuccessResponse(response)) {
        await customerContainer.getPaymentsForDashboard()
      }
    }
    this.handleDeleteConfirmationModalClose()
  }

  renderDeletePaymentMethodContent = () => {
    const { selectedPaymentForDelete: cardData = {} } = this.props
    const cardNumber = cardData?.accountInfo?.cardNumber || ''
    const cardProvider = cardData?.accountInfo?.provider || ''
    const paymentName = cardData?.name || ''
    const isSepaPayment = isSepaPaymentRecord({
      name: paymentName,
      type: cardData?.type,
    })
    const sepaToken =
      cardData?.accountInfo?.token ||
      cardData?.accountInfo?.iban ||
      cardData?.accountInfo?.IBAN ||
      cardData?.properties?.iban ||
      ''
    const sepaEndingDigits = sepaToken ? sepaToken.slice(-4) : ''

    if (isSepaPayment) {
      return (
        <div>
          <div className="delete-msg-wrapper">
            <span>
              {i18nTranslate('cart.delete', 'Delete')}
              &nbsp;
            </span>
            <span>
              {i18nTranslate(
                'payment.sepaDirectDebitEndingIn',
                'Sepa Direct Debit ending in '
              )}
            </span>
            <span>{sepaEndingDigits}&nbsp;</span>
            <span>
              {i18nTranslate(
                'payment.deleteMessageEnd',
                'from your saved payments?'
              )}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <Button
              className="btn btn-outline-primary cancel-btn"
              onClick={this.handleDeleteConfirmationModalClose}>
              {i18nTranslate('address.cancel', 'Cancel')}
            </Button>
            <Button
              className="btn btn-primary confirm-btn"
              onClick={() => {
                this.handleDeletePayment().catch(error => {
                  console.error('Failed to delete payment:', error)
                })
              }}>
              {i18nTranslate('payment.confirmDelete', 'Confirm Delete')}
            </Button>
          </div>
        </div>
      )
    }

    if (cardNumber && cardProvider) {
      return (
        <div>
          <div className="delete-msg-wrapper">
            <span>
              {i18nTranslate('cart.delete', 'Delete')}
              &nbsp;
            </span>
            <span>{capitalizeFirstLetter(cardProvider)} &nbsp;</span>
            <span>****{cardNumber}&nbsp;</span>
            <span>
              {i18nTranslate(
                'payment.deleteMessageEnd',
                'from your saved payments?'
              )}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <Button
              className="btn btn-outline-primary cancel-btn"
              onClick={this.handleDeleteConfirmationModalClose}>
              {i18nTranslate('address.cancel', 'Cancel')}
            </Button>
            <Button
              className="btn btn-primary confirm-btn"
              onClick={() => {
                this.handleDeletePayment().catch(error => {
                  console.error('Failed to delete payment:', error)
                })
              }}>
              {i18nTranslate('payment.confirmDelete', 'Confirm Delete')}
            </Button>
          </div>
        </div>
      )
    }

    if (paymentName) {
      return (
        <div>
          <div className="delete-msg-wrapper">
            <span>
              {i18nTranslate('cart.delete', 'Delete')}
              &nbsp;
            </span>
            <span className="font-weight-bold">
              {capitalizeFirstLetter(paymentName)}&nbsp;
            </span>
            <span>
              {i18nTranslate(
                'payment.deleteMessageEnd',
                'from your saved payments?'
              )}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <Button
              className="btn btn-outline-primary cancel-btn"
              onClick={this.handleDeleteConfirmationModalClose}>
              {i18nTranslate('address.cancel', 'Cancel')}
            </Button>
            <Button
              className="btn btn-primary confirm-btn"
              onClick={() => {
                this.handleDeletePayment().catch(error => {
                  console.error('Failed to delete payment:', error)
                })
              }}>
              {i18nTranslate('payment.confirmDelete', 'Confirm Delete')}
            </Button>
          </div>
        </div>
      )
    }

    return <p>{i18nTranslate('subscription.paymentTitle', 'Payment method')}</p>
  }

  render() {
    const { isToShowDeleteModal = false } = this.props
    return (
      <Modal
        className={`visible modal-wrapper p-0`}
        show={isToShowDeleteModal}
        onHide={this.handleDeleteConfirmationModalClose}
        centered
        animation={false}>
        <Modal.Header
          closeButton={this.handleDeleteConfirmationModalClose}
          className={'border-bottom-0'}>
          <Modal.Title className="title-Payment-Modal">
            {i18nTranslate('checkout.deletePayment', 'Delete payment method')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderDeletePaymentMethodContent()}</Modal.Body>
      </Modal>
    )
  }
}

export default PaymentDeleteModal
export { PaymentDeleteModal }
